const hasOwn = (value, key) => (
  Boolean(value)
  && Object.prototype.hasOwnProperty.call(value, key)
);

const decisionsEqual = (left, right) => {
  if (left === right) return true;
  if (!left || !right) return false;
  return (
    left.reason_code === right.reason_code
    && left.summary === right.summary
    && Boolean(left.paid_purchase_review) === Boolean(right.paid_purchase_review)
  );
};
export const mergeAccountGateState = (current, status) => {
  if (!current || typeof current !== "object") return current;
  if (!status || typeof status !== "object") return current;

  const blocked = hasOwn(status, "blocked")
    ? Boolean(status.blocked)
    : Boolean(current.blocked);
  const blockReason = hasOwn(status, "block_reason")
    ? status.block_reason || ""
    : current.block_reason || "";
  const moderationDecision = hasOwn(status, "decision")
    ? status.decision || null
    : current.moderation_decision || null;
  const legalReacceptRequired = hasOwn(status, "legal_reaccept_required")
    ? Boolean(status.legal_reaccept_required)
    : Boolean(current.legal_reaccept_required);

  if (
    Boolean(current.blocked) === blocked
    && (current.block_reason || "") === blockReason
    && decisionsEqual(current.moderation_decision || null, moderationDecision)
    && Boolean(current.legal_reaccept_required) === legalReacceptRequired
  ) {
    return current;
  }

  return {
    ...current,
    blocked,
    block_reason: blockReason,
    moderation_decision: moderationDecision,
    legal_reaccept_required: legalReacceptRequired,
  };
};
